const SummaryModule = ({
  title,
  subtitle = "",
  content,
  col = false,
  colSpan = 0,
}) => {
  const rednerBullentinIcon = () => {
    switch (title.toLowerCase()) {
      case "key shifts":
        if (content.length > 0) {
          const token = content[0][0];
          if (token === "↑") {
            return (
              <span className="mt-1 text-sm font-bold text-[#DB4225]">▲</span>
            );
          } else if (token === "=") {
            return (
              <span className="mt-1 text-sm font-bold text-[#DB4225]">=</span>
            );
          } else {
            return (
              <span className="mt-1 text-sm font-bold text-[#DB4225]">▼</span>
            );
          }
        }

      case "topics insight summary":
        return <span className="text-xl font-bold">•</span>;
    }
  };
  return (
    <section
      className={`h-auto w-full rounded-lg bg-white p-6 text-left shadow-socialglass ${
        col ? `col-span-${colSpan}` : ""
      }`}
    >
      {" "}
      <h1 className="m-0 mb-4 p-0 text-left text-lg font-medium text-[#DB4225]">
        {title}
      </h1>
      {subtitle !== "" && <p className="">{subtitle}</p>}
      <div className="m-0 space-y-6 p-0">
        {content.map((cont, index) => (
          <div key={index} className="m-0 flex items-start gap-2 p-0">
            {rednerBullentinIcon()}
            <p className="m-0 p-0 text-left text-lg leading-relaxed text-gray-700">
              {title.toLowerCase() === "key shifts" ? cont.slice(1) : cont}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SummaryModule;
